const operationTypes = {
    readOnly : 'readOnly',
    createImage : 'createImage',
    dropImage : 'dropImage',
    createClone : 'createClone',
    dropClone : 'dropClone'
};

export default operationTypes;

export const operationTypeToPresentParticiple = operationType =>
{
    switch (operationType)
    {
        case operationTypes.createImage:
        case operationTypes.createClone:
            return 'Creating';
        case operationTypes.dropImage:
        case operationTypes.dropClone:
            return 'Deleting';
        default:
            return 'Working';
    }
};

export const operationTypeToNoun = operationType =>
{
    switch (operationType)
    {
        case operationTypes.createImage:
        case operationTypes.createClone:
            return 'Creation';
        case operationTypes.dropImage:
        case operationTypes.dropClone:
            return 'Deletion';
        default:
            return 'Operation';
    }
};


// WEBPACK FOOTER //
// ./src/js/operationTypes.js